import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import Spinner from "../../../components/Common/Spinner";
import {
  LoadingContainer,
  LoadingText,
} from "../styles/DetallesPacienteStyles";

const LoadingState = ({ message = "Cargando validaciones de hojas quirúrgicas..." }) => {
  return (
    <CustomLayout showMenuNav={true} footerWidth={"auto"}>
      <Section>
        <LoadingContainer>
          <Spinner size={60} />
          <LoadingText>{message}</LoadingText>
        </LoadingContainer>
      </Section>
    </CustomLayout>
  );
};

export default LoadingState;

